module.exports = __webpack_public_path__ + "ad43b5ec855ddd90237b16c78dce471a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ping-pong.png
// module id = 3034
// module chunks = 0